import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

/* Layout */
import Layout from "@/layout";
import Layout_2 from "@/views/dashboard/policyService/index";
import Layout_3 from "@/views/userView/index";
import cuttingEdgeRouter from "./modules/cuttingEdgeRouter";
/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/",
    name: "index",
    redirect: "/policy/policySearch",
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index"),
    hidden: true
  },
  {
    path: "/user",
    component: Layout,
    redirect: "/user/center",
    name: "userView",
    hidden: true,
    meta: {
      title: "个人中心",
      sort: 5
    },
    children: [
      {
        path: "center",
        component: Layout_2,
        redirect: "/user/center/view",
        name: "userRouter",
        meta: {
          title: "userRouterView"
        },
        children: [
          {
            path: "view",
            component: Layout_3,
            redirect: "/user/center/view/info",
            name: "userview2",
            meta: {
              title: "userInfoMenu"
            },
            children: [
              {
                path: "info",
                component: () => import("@/views/userView/JBXX"),
                name: "userInfo",
                meta: {
                  title: "个人中心",
                  group: "userCenter"
                }
              },
              {
                path: "innovate",
                component: () => import("@/views/userView/YFCX"),
                name: "userInnovate",
                meta: {
                  title: "研发创新",
                  group: "userCenter"
                }
              },
              {
                path: "field",
                component: () => import("@/views/userView/CFCD"),
                name: "userField",
                meta: {
                  title: "厂房场地",
                  group: "userCenter"
                }
              },
              {
                path: "resources",
                component: () => import("@/views/userView/RLZY"),
                name: "userResources",
                meta: {
                  title: "人力资源",
                  group: "userCenter"
                }
              },
              {
                path: "financing",
                component: () => import("@/views/userView/RZSS"),
                name: "userFinancing",
                meta: {
                  title: "融资上市",
                  group: "userCenter"
                }
              },
              {
                path: "produce",
                component: () => import("@/views/userView/SCJY"),
                name: "userProduce",
                meta: {
                  title: "生产经营",
                  group: "userCenter"
                }
              },
              {
                path: "safe",
                name: "userSafe",
                component: () => import("@/views/userView/userSafe"),
                meta: {
                  title: "账户安全",
                  group: "userCenter"
                }
              }
            ]
          }
        ]
      }
    ]
  },
  cuttingEdgeRouter,
  {
    path: "/site",
    name: "site",
    component: Layout,
    redirect: "/site/view",
    meta: {
      title: "产业资源一张图",
      icon: "my_yizhangtu"
    },
    hidden: true,
    children: [
      {
        path: "view",
        name: "siteView",
        component: () => import("@/views/industryResource/site"),
        meta: {
          title: "企业选址",
          group: "policy"
        }
      },
      {
        path: "park",
        name: "sitePark",
        component: () =>
          import("@/views/industryResource/resourceInfo/park.vue"),
        meta: {
          title: "园区"
        }
      },
      {
        path: "building",
        name: "siteBuilding",
        component: () =>
          import("@/views/industryResource/resourceInfo/building.vue"),
        meta: {
          title: "楼宇"
        }
      },
      {
        path: "land",
        name: "siteLand",
        component: () =>
          import("@/views/industryResource/resourceInfo/land.vue"),
        meta: {
          title: "用地"
        }
      }
    ]
  },

  { path: "*", redirect: "/404", hidden: true }
];
export const asyncRoutes = [];

const createRouter = () =>
  new Router({
    base: process.env.BASE_URL,
    mode: "history", // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;
